<template>
  <button
    class="flex flex-row border border-1 border-GREY rounded-lg p-3 items-center justify-between w-full transition-all duration-300"
    :class="onPressClass"
    @touchstart="onPressClass = 'bg-white bg-opacity-15'"
    @touchend="onPressClass = ''"
    @click="emit('openActivityDetail', data)"
  >
    <div class="flex flex-row items-start gap-2 w-full">
      <div class="bg-LIGHTGREY rounded w-6 h-6 items-center justify-center flex"></div>
      <div class="flex flex-col gap-2.5 items-start justify-center w-full">
        <p class="font-medium text-white text-sm text-left">
          {{ data.title }}
        </p>
        <div class="w-full flex items-center justify-between">
          <div v-if="data.type == 'upgrade'" class="flex items-center gap-2">
            <p class="text-xs text-GREY font-medium text-left max-w-[80%]">
              {{ data.subtitle }}
            </p>
            <div class="flex items-center gap-1">
              <p class="text-xs text-GREY font-medium">lvl1</p>
              <font-awesome-icon size="xs" class="green-icon" :icon="['fas', 'angles-right']" />
              <p class="text-xs text-GREY font-medium">lvl2</p>
            </div>
          </div>
          <p v-else class="text-xs text-GREY font-medium text-left max-w-[80%]">
            {{ data.subtitle }}
          </p>
          <div class="flex flex-row gap-1.5">
            <img src="../assets/icons/token-2.svg" class="h-4 object-contain" />
            <p class="text-xs text-white font-bold">{{ data.currency }}</p>
          </div>
        </div>
      </div>
    </div>
  </button>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  data: {
    type: Object,
    default: () => {}
  }
})

const onPressClass = ref('')

const emit = defineEmits(['openActivityDetail'])
</script>

<style></style>
